import { render, staticRenderFns } from "./DiscountSetting.vue?vue&type=template&id=5cee09e2&scoped=true&"
import script from "./DiscountSetting.vue?vue&type=script&lang=js&"
export * from "./DiscountSetting.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSetting.vue?vue&type=style&index=0&id=5cee09e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee09e2",
  null
  
)

export default component.exports